import { IsBoolean } from "class-validator";

export class AdminConvertLeadResult {
    @IsBoolean()
    success: boolean;
}